<template>
  <div>
    <div class="detail_buts" v-if="mode == 'product'">
      <a href="javascript:void(0)" @click="addToWaitList" class="detail_but-right btn-gray" style="min-width: 230px;" >Добавить в лист ожидания </a>
    </div>
    <div class="catList_item_buts" v-else>
      <a href="javascript:void(0)" @click="addToWaitList" class="btn-gray"  >В лист ожидания </a>
    </div>
  </div>
</template>

<script>

import AddToWaitListDialog from "./AddToWaitListDialog";
export default {
  name: 'AddToWaitListButton',
  props: ['product', 'mode'],
  data () {
    return {
      count: 1
    }
  },
  methods: {
    addToWaitList() {
      // this.$store.commit('addToWaitList', this.product);
      this.$modal.show(
          AddToWaitListDialog,
          { product: this.product },
          { height: 'auto' }
      )
      window.ym(39587615,'reachGoal','click.add.to.wait.list')
    },
  }
}
</script>

<style scoped>
  .catList_item_buts .btn-gray {
    width: 100% !important;
  }
</style>